const biases = [
  {
    icon: 'ri-heart-line',
    title: 'Sesgo de equipo favorito',
    color: '#ef4444',
    desc: 'Apostar por tu equipo favorito porque lo quieres, no porque tenga valor. El mercado ya descuenta el exceso de apuestas emocionales en los favoritos populares.',
    fix: 'Evita apostar en partidos donde tienes implicación emocional. Si lo haces, sé consciente del sesgo y reduce el stake.',
  },
  {
    icon: 'ri-history-line',
    title: 'Falacia del jugador',
    color: '#f59e0b',
    desc: 'Creer que tras 5 derrotas seguidas "toca ganar". Los eventos independientes no tienen memoria. Una racha negativa no aumenta la probabilidad del siguiente resultado.',
    fix: 'Cada apuesta es independiente. Evalúa el valor de cada selección por sus propios méritos, no por resultados anteriores.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Sesgo de confirmación',
    color: '#8b5cf6',
    desc: 'Buscar solo información que confirme tu apuesta ya decidida e ignorar datos contrarios. Lleva a sobreestimar la confianza en selecciones débiles.',
    fix: 'Busca activamente argumentos en contra de tu apuesta. Si no puedes rebatirlos, reconsidera la selección.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Tilt y chasing losses',
    color: '#ef4444',
    desc: 'Aumentar stakes o hacer apuestas impulsivas para recuperar pérdidas rápidamente. Es el error más destructivo y la causa principal de ruina del bankroll.',
    fix: 'Establece un límite de pérdidas diario. Si lo alcanzas, para. Nunca aumentes el stake para recuperar pérdidas.',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Sesgo de resultado',
    color: '#06b6d4',
    desc: 'Juzgar la calidad de una apuesta por su resultado en lugar de por el proceso. Una apuesta mala puede ganar y una buena puede perder. El largo plazo es lo que importa.',
    fix: 'Evalúa tus apuestas por el proceso: ¿tenía valor? ¿el análisis era correcto? El resultado individual es irrelevante.',
  },
  {
    icon: 'ri-bar-chart-line',
    title: 'Sobreconfianza',
    color: '#f59e0b',
    desc: 'Creer que eres mejor estimando probabilidades de lo que realmente eres. La mayoría de apostadores sobreestiman su ventaja sobre el mercado.',
    fix: 'Lleva un registro detallado y calcula tu ROI real. Los datos no mienten. Sé honesto sobre tu rendimiento.',
  },
];

const rules = [
  { num: '01', title: 'Define tu bankroll antes de empezar', desc: 'Decide cuánto dinero vas a destinar a las apuestas y no lo superes nunca. Este dinero debe ser prescindible.' },
  { num: '02', title: 'Establece límites de pérdidas', desc: 'Fija un máximo de pérdidas diario, semanal y mensual. Cuando lo alcances, para sin excepciones.' },
  { num: '03', title: 'Nunca apuestes bajo presión emocional', desc: 'Si estás enfadado, eufórico o bajo estrés, no apuestes. Las emociones distorsionan el juicio.' },
  { num: '04', title: 'Tómate descansos regulares', desc: 'El juego continuo deteriora la toma de decisiones. Programa descansos y respétalos.' },
  { num: '05', title: 'Busca ayuda si la necesitas', desc: 'Si sientes que el juego está afectando tu vida, llama al 900 200 225 (FEJAR). Es gratuito y confidencial.' },
];

export default function PsychologySection() {
  return (
    <section id="psicologia" className="py-20 bg-[#080a0f]">
      <div className="max-w-[1440px] mx-auto px-6">
        {/* Header */}
        <div className="flex items-start gap-4 mb-12">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#8b5cf6]/10 border border-[#8b5cf6]/20 flex-shrink-0">
            <i className="ri-shield-check-line text-[#8b5cf6] text-xl"></i>
          </div>
          <div>
            <p className="text-[#8b5cf6] text-xs font-semibold uppercase tracking-widest mb-1">Capítulo 3</p>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: "'Syne', sans-serif" }}>
              Psicología del Apostador
            </h2>
            <p className="text-[#a8b2c1] text-base max-w-2xl">
              El mayor enemigo del apostador no es la casa, eres tú mismo. Conocer los sesgos cognitivos y controlar las emociones es tan importante como cualquier estrategia.
            </p>
          </div>
        </div>

        {/* Biases grid */}
        <h3 className="text-white font-bold text-lg mb-5" style={{ fontFamily: "'Syne', sans-serif" }}>Sesgos cognitivos más comunes</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">
          {biases.map((b) => (
            <div key={b.title} className="p-5 bg-[#0d0f14] border border-[#1e2028] rounded-xl hover:border-[#2a2d3a] transition-colors">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg" style={{ backgroundColor: `${b.color}15` }}>
                  <i className={`${b.icon} text-base`} style={{ color: b.color }}></i>
                </div>
                <h4 className="text-white font-semibold text-sm">{b.title}</h4>
              </div>
              <p className="text-[#6b7280] text-xs leading-relaxed mb-3">{b.desc}</p>
              <div className="p-2.5 bg-[#080a0f] rounded-lg border border-[#1e2028]">
                <p className="text-[#00e87a] text-xs font-semibold mb-0.5">Solución</p>
                <p className="text-[#a8b2c1] text-xs leading-relaxed">{b.fix}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Juego responsable */}
        <div className="bg-[#0d0f14] border border-[#1e2028] rounded-2xl overflow-hidden">
          <div className="p-6 border-b border-[#1e2028] flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#00e87a]/10">
              <i className="ri-heart-pulse-line text-[#00e87a] text-lg"></i>
            </div>
            <div>
              <h3 className="text-white font-bold text-lg">Juego Responsable</h3>
              <p className="text-[#6b7280] text-xs">5 reglas que todo apostador debe seguir</p>
            </div>
          </div>
          <div className="divide-y divide-[#1e2028]">
            {rules.map((r) => (
              <div key={r.num} className="flex items-start gap-5 p-5">
                <span className="text-[#2a2d3a] font-bold text-2xl flex-shrink-0" style={{ fontFamily: "'Syne', sans-serif" }}>{r.num}</span>
                <div>
                  <h4 className="text-white font-semibold text-sm mb-1">{r.title}</h4>
                  <p className="text-[#6b7280] text-xs leading-relaxed">{r.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
